module.exports = __webpack_public_path__ + "img/fog.1c94566b.svg";